import { ColumnDef } from "@tanstack/react-table";
import { KTIcon } from "helpers";
import React from "react";
import UserStatusBadge from "../users/UserStatusBadge";
export type User = {
  guid: string;
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email: string;
  address1: string;
  address2: string;
  status: string;
  pinCode: string;
  city: {
    guid: string;
    displayName: string;
    state: {
      guid: string;
      displayName: string;
      country: {
        guid: string;
        displayName: string;
      };
    };
  };
};

// Actions cell moved out as a separate component
type ActionsCellProps = { row: any };
export const ActionsCell: React.FC<ActionsCellProps> = ({ row }) => (
  <div className="d-flex gap-2">
    <button
      onClick={() => console.log(row)}
      className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
    >
      <KTIcon iconName="pencil" className="fs-3" />
    </button>
    <button
      onClick={() => console.log(row)}
      className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
    >
      <KTIcon iconName="trash" className="fs-3" />
    </button>
  </div>
);

// Factory function to generate columns with selection logic injected
export const getAssignedUsersColumns = (
  isSelected: (guid: string) => boolean,
  toggleSelection: (guid: string) => void,
  selectAll: () => void,
  clearAllSelections: () => void,
  selectedGuids: Set<string>,
  usersInThisRole: User[]
): ColumnDef<User>[] => [
  {
    header: "User",
    cell: ({ row }) => (
      <>
        {row.original.firstName ?? <span className="fw-bold ms-2">-</span>}{" "}
        {row.original.lastName ?? ""}
      </>
    ),
  },
  {
    accessorKey: "email",
    header: "Email",
  },
  {
    header: "Status",
    cell: ({ row }) => <UserStatusBadge status={row.original.status} />,
  },
];
